<template>
    <div class="login-layout h-100 admin-layout" @click="handleOutsideClick">
        <header>
            <router-link to="/" class="logo">
                <img v-if="comp_id == 2" src="@/assets/img/ringobell_logo_white.png" alt="로고" height="21" />
                <img v-else src="@/assets/img/syscall_logo_white.png" alt="로고" height="21" class="logo" />
            </router-link>

            <h1>음성통화비상벨 통합 관리 <span class="dn"> 프로그램</span></h1>
            <div class="profile" ref="profile">
                <!-- <router-link to="/device" class="godeviceBtn">장치관리</router-link> -->
                <!-- <router-link to="/home" class="godeviceBtn">관리처관리</router-link> -->
                <!-- 사용자 정보 표시 -->
                <div v-if="$route.path != '/login'" class="user-info" @click="toggleDropdown">
                    <span>{{ display_name }}</span>
                    <img :src="thumbnailUrl" alt="사용자썸네일" class="thumbnail" />
                    <svg xmlns="http://www.w3.org/2000/svg" width="24" height="24" viewBox="0 0 24 24" fill="none">
                        <mask id="mask0_525_2089" style="mask-type: alpha" maskUnits="userSpaceOnUse" x="0" y="0" width="24" height="24">
                            <rect width="24" height="24" fill="#D9D9D9" />
                        </mask>
                        <g mask="url(#mask0_525_2089)">
                            <path d="M12 15.3746L6 9.37461L7.4 7.97461L12 12.5496L16.6 7.97461L18 9.37461L12 15.3746Z" fill="white" />
                        </g>
                    </svg>
                </div>
                <!-- 드롭다운 메뉴 -->
                <ul v-if="dropdownVisible" class="dropdown-menu">
                    <li @click="logout">로그아웃</li>
                </ul>
            </div>
        </header>
        <section class="content">
            <router-view></router-view>
        </section>
    </div>
</template>

<script>
import { supabase } from '@/API/supabase';
import S_favicon_default from '@/assets/favicon/S_favicon_default.ico';
import R_favicon_default from '@/assets/favicon/R_favicon_default.ico';

import '../../assets/css/admin.css';

export default {
    name: 'LoginLayout',
    data() {
        return {
            defaultImg: require('@/assets/img/user.png'),
            dropdownVisible: false,
            user_id: '',
            comp_id: '',
            auth: '',
            display_name: '',
            thumb: '',
            thumbnailUrl: '',
        };
    },
    mounted() {
        // favicon 변경 (도메인에 따라 기본 아이콘 사용)
        if (window.location.hostname.includes('ringosos')) {
            this.changeFavicon(R_favicon_default);
        } else {
            this.changeFavicon(S_favicon_default);
        }

        var user = this.$store.state.user;
        if (user.data) {
            var userInfo = user.data;
            this.user_id = userInfo.user_id;
            this.comp_id = userInfo.comp_id;
            this.auth = userInfo.auth;
            this.display_name = userInfo.display_name;
            this.thumb = userInfo.thumb;
            if (this.thumb != null && this.thumb != '' && this.thumb != 'null') {
                this.downloadThumbnail();
            } else {
                this.thumbnailUrl = this.defaultImg;
            }
        }

        this.emitter.on('setHeader', this.setHeader);
        this.emitter.on('refreshHeader', this.refreshHeader);

        // 전역 클릭 이벤트 등록
        window.addEventListener('click', this.handleOutsideClick);
    },
    beforeDestroy() {
        this.emitter.off('setHeader', this.setHeader);
        this.emitter.off('refreshHeader', this.refreshHeader);
        // 전역 클릭 이벤트 제거
        window.removeEventListener('click', this.handleOutsideClick);
    },
    methods: {
        // 썸네일 다운로드
        async downloadThumbnail() {
            const { data, error } = await supabase.storage.from('thumbnail').download(`images/${this.user_id}`);

            if (error) {
                console.error(error);
                return;
            } else {
                const blobUrl = URL.createObjectURL(data);
                this.thumbnailUrl = blobUrl; // <img> 태그에 적용
            }
        },

        // 헤더 정보 설정
        setHeader(userInfo) {
            this.comp_id = userInfo.comp_id;
            this.display_name = userInfo.display_name;
            this.thumb = userInfo.thumb;
            this.auth = userInfo.auth;
            if (this.thumb != null && this.thumb != '' && this.thumb != 'null') {
                this.downloadThumbnail();
            } else {
                this.thumbnailUrl = this.defaultImg;
            }
        },

        // 헤더 정보 업데이트
        refreshHeader(userInfo) {
            this.comp_id = userInfo.comp_id;
            this.display_name = userInfo.display_name;

            this.$store.commit('resetAdminProfile', userInfo);
        },

        toggleDropdown() {
            this.dropdownVisible = !this.dropdownVisible;
        },
        handleOutsideClick(event) {
            // 드롭다운 외부를 클릭했는지 확인
            if (this.$refs.profile && !this.$refs.profile.contains(event.target)) {
                this.dropdownVisible = false;
            }
        },
        // 파비콘 변경
        changeFavicon(iconUrl) {
            let link = document.querySelector("link[rel='icon']");
            if (link) {
                document.head.removeChild(link);
            } else {
                link = document.createElement('link');
                link.rel = 'icon';
            }
            link.href = iconUrl + '?v=' + new Date().getTime(); // 캐싱 방지
            document.head.appendChild(link);
        },

        // 로그아웃
        async logout() {
            var result = await this.$confirm('로그아웃 하시겠습니까?');
            if (result) {
                var params = {
                    user_id: this.user_id,
                };

                this.$store
                    .dispatch('UserAccountStore/logout', params)
                    .then((res) => {
                        this.dropdownVisible = false;
                        this.comp_id = '';
                        this.display_name = '';
                        this.thumb = '';
                        this.thumbnailUrl = '';
                        this.$store.commit('logoutUser');

                        // 앱쪽으로 URL 전달
                        if (window.jsBridge && typeof window.jsBridge.postMessage === 'function') {
                            window.jsBridge.postMessage('logout');
                        }

                        this.$router.push('/login');
                        return res;
                    })
                    .catch(({ message }) => alert(message));
            }
        },
    },
};
</script>
